<template>
  <v-container fluid class="pa-0 bg-slate-50 min-h-screen" style="font-family: 'Inter', sans-serif;">
    <div class="p-4 md:p-8">
      <div class="max-w-3xl mx-auto">
        
        <!-- HEADER -->
        <div class="mb-8 flex items-center justify-between">
          <div>
            <button 
              @click="$router.push(`/biddings-manager/edit/${data.bidding_id}`)"
              class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-all mb-2 group"
            >
              <v-icon small color="currentColor" class="transition-transform group-hover:-translate-x-1">mdi-arrow-left</v-icon>
              <span class="text-[10px] font-black uppercase tracking-[0.2em]">Voltar</span>
            </button>
            <h1 class="text-2xl font-bold text-slate-700 tracking-tight">Dotação Orçamentária</h1>
            <p class="text-sm text-slate-500 font-medium">{{ id ? 'Editando informações da dotação' : 'Vincular nova unidade orçamentária à licitação' }}</p>
          </div>
        </div>

        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="space-y-6">
            
            <!-- SEÇÃO: UNIDADE ORÇAMENTÁRIA -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
                <v-icon color="orange" small>mdi-office-building-marker-outline</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">DADOS DA UNIDADE</h2>
              </div>
              
              <div class="p-6">
                <div class="grid grid-cols-1 gap-6">
                  <!-- Unidade -->
                  <div>
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Unidade Orçamentária</label>
                    <v-autocomplete
                      v-model="data.sec_id"
                      :items="prefectures_sec"
                      item-value="sec_id"
                      item-text="sec_name"
                      :rules="fieldRules"
                      placeholder="SELECIONE A UNIDADE..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>
                </div>
              </div>
            </section>

            <!-- BOTÕES DE AÇÃO -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="bg-slate-50 px-8 py-5 flex justify-end items-center gap-4">
                <button 
                  @click="$router.push(`/biddings-manager/edit/${data.bidding_id}`)"
                  class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
                >
                  Cancelar
                </button>
                <div class="flex-none">
                  <button
                    @click="validate"
                    :disabled="!valid || loader"
                    class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
                  >
                    <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
                    <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                    <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
                  </button>
                </div>
              </div>
            </section>

          </div>
        </v-form>
      </div>
    </div>

    <!-- NOTIFICAÇÕES -->
    <v-snackbar multi-line border="left" :color="snack.color" v-model="snack.show" transition="scroll-y-reverse-transition" class="mb-6">
      <div class="flex items-center gap-3">
        <v-icon color="white">mdi-information-outline</v-icon>
        <span class="font-bold text-xs uppercase tracking-wider text-white">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon small color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
export default {
  props: ["b_id", "id", "p_id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures_sec: [],
    fieldRules: [v => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success"
    },
    data: {
      bugget_donation_id: null,
      bidding_id: null,
      sec_id: null
    }
  }),
  created() {
    this.$http
      .get(`/prefectures/secretariats/${this.p_id}`)
      .then(r => (this.prefectures_sec = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/biddings/donnations/single/${this.id}`).then(r => {
        this.data = r.data[0];
        this.$store.dispatch("setLoader", false);
      });
    } else {
      this.data.bidding_id = Number(this.b_id);
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      const method = this.id ? 'put' : 'post';
      const url = this.id ? `/biddings/donnations/single/${this.id}` : "/biddings/donnations";

      this.$http[method](url, this.data)
        .then(r => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.snack.color = "success";
          setTimeout(() => {
            this.$router.push(`/biddings-manager/edit/${this.data.bidding_id}`);
          }, 1500);
        })
        .catch(e => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    }
  }
};
</script>

<style scoped>
.custom-select ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  border-radius: 4px !important;
  height: 48px !important;
  padding: 0 16px !important;
}

.custom-select ::v-deep input {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #334155 !important;
  text-transform: uppercase !important;
}

.custom-select ::v-deep .v-label {
  font-size: 10px !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.15em !important;
  color: #94a3b8 !important;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
</style>